import React, { useEffect, useState } from "react";
import {
	askDataKeyValue,
	askDataKeyValue2Simple,
	updateDocumentById,
} from "../../../../utils/actions/firebase/firebaseActions";
import Loader from "../../../generalComponents/Loader";

export const RegProcessOrderTableRow = ({ el, irVerDetalle, company }) => {
	// console.log("****** que hay en el.********", el);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [questions, setQuestions] = useState(el.questions);
	const processRegister = el;
	const jsonValue = localStorage.getItem("userLocal");
	const localUser = JSON.parse(jsonValue);
	const email = localUser.email;

	const updateQuestions = async () => {
		// console.log("< < < < < va a ejecutar updateQuestions");
		if (el.questions === 0 || !el.questions || el.questions > el.responses) {
			// console.log("++***+++*** ingresó a grabar questions");
			const resp = await askDataKeyValue2Simple(
				"activitiesRegister-" + company,
				"process",
				el.process,
				"processNumber",
				el.processNumber
			);
			const activitiesList = resp.data;
			const questions1 = activitiesList.length;
			processRegister.questions = questions1;
			// console.log("______ antes del update que no funcioona el:", el);
			// console.log(
			// 	"______ antes del update que no funcioona processRegister:",
			// 	processRegister
			// );
			try {
				await updateDocumentById(
					"processRegister-" + company,
					el.id,
					processRegister
				);
				setQuestions(questions1);
			} catch (error) {
				console.log("*** erorr: ", error);
			}
		}
	};
	useEffect(() => {
		updateQuestions();
	}, []);

	const changeStatus = async (newStatus) => {
		setLoading(true);
		const nameCollection = "assignments-" + company;
		const key2 = "processNumber";
		const value2 = el.processNumber;
		const response = await askDataKeyValue(nameCollection, key2, value2);
		if (response.statusResponse === true) {
			const assignments = response.data;
			assignments.map((assignment) => {
				if (newStatus === "cerrado") {
					//deterner reloj si está corriendo...
					if (assignment.statusActingTime === "si") {
						const fechita = new Date();
						const fechitaMlSeconds = fechita.getTime(); // para pasar a milisegundos
						const eventsTime = assignment.eventsTime;
						const totalEventsTime = eventsTime.length - 1;
						eventsTime[totalEventsTime].f = fechitaMlSeconds; //cambia el valor final de tiempo del evento último
						eventsTime[totalEventsTime].stopCause = "superior";
						eventsTime[totalEventsTime].comment = email;
						const timeMls =
							eventsTime[totalEventsTime].f - eventsTime[totalEventsTime].i;
						assignment.statusActingTime = "pausado";
						assignment.eventsTime = eventsTime;
						assignment.totalTime = assignment.totalTime + timeMls;
					}
				}
				assignment.status = newStatus;
				const docId = assignment.id;
				const changes = assignment;

				updateDocumentById(nameCollection, docId, changes);
			});
			processRegister.status = newStatus;
			const collection = "processRegister-" + company;
			const docId = processRegister.id;
			const changes = processRegister;
			updateDocumentById(collection, docId, changes);
			setLoading(false);
		} else {
			setError(response.error);
			setLoading(false);
		}
		setLoading(false);
	};

	const buttonAction = (el) => {
		localStorage.setItem("regProceso", el.processNumber);
		localStorage.setItem("proceso", el.process);
		localStorage.setItem("totalRegProcess", JSON.stringify(el));
		irVerDetalle();
	};

	const buttonChangeStatus = async () => {
		let newStatus = "";
		if (el.status === "abierto") {
			newStatus = "cerrado";
		} else {
			newStatus = "abierto";
		}
		await changeStatus(newStatus);
	};

	if (loading === true) {
		return <Loader />;
	} else {
		return (
			<tr className="fila-tabla-cuenstas">
				<td className="col-tabla-regtarea1">{el.date1}</td>
				<td className="col-tabla-regtarea1">{el.hour1}</td>
				<td className="col-tabla-regtarea2">{el.processNumber}</td>
				<td className="col-tabla-regprocesos1">{el.process}</td>
				<td className="col-tabla-regtarea2">{el.refProductionProduct}</td>
				<td className="col-tabla-regtarea2">
					{el.finishProduct}/{el.quantity}
				</td>
				<td className="col-tabla-regprocesos2">{el.status}</td>
				<td className="col-tabla-regprocesos2">
					<div>
						{el.status === "abierto" ? (
							<button
								onClick={() => buttonChangeStatus()}
								className="btnCloseRegprocesos"
							>
								Cerrar
							</button>
						) : (
							<button
								onClick={() => buttonChangeStatus()}
								className="btnOpenRegprocesos"
							>
								Abrir
							</button>
						)}
					</div>
				</td>
				<td className="col-tabla-regprocesos2">
					{Math.round(el.complianceProcess * 100)}%
				</td>
				<td className="col-tabla-regprocesos2">
					{el.responses === el.questions ? (
						<div className="responseColorFull">
							{console.log("respuestas: ", el.responses)}
							{console.log("preguntas: ", el.questions)}
							<p>{Math.round((el.responses * 100) / el.questions)}%</p>
						</div>
					) : (
						<div className="responseColorEmpty">
							<p>{Math.round((el.responses * 100) / el.questions)}%</p>
						</div>
					)}
				</td>
				<td className="col-tabla-regprocesos2">
					<button
						onClick={() => buttonAction(el)}
						className="btn-ver-regprocesos"
					>
						Ver
					</button>

					{/* <button
						onClick={() => buttonChangeStatus()}
						className="btnOpenRegprocesos"
					>
						{el.status === "abierto" ? "Cerrar" : "Abrir"}
					</button> */}
				</td>
			</tr>
		);
	}
};
